(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["colour-group-swatches"] && !Shopify.designMode) return;
  try {
    // The size the shopper picked on this page, carried to the next colour so it
  // doesn't fall back to the first available size (38). Only an explicit pick
  // counts: a variant change, or a ?variant= the page was opened with.
  var colourGroupChosenSize = null;

  function colourGroupSizeMap(link) {
    try {
      return JSON.parse(link.dataset.sizeVariants || '{}');
    } catch (error) {
      return {};
    }
  }

  document.addEventListener('variant:update', function (event) {
    var variant = event.detail && event.detail.resource;
    if (!variant || !variant.option1) return;

    colourGroupChosenSize = String(variant.option1);
    document.querySelectorAll('colour-group-swatches').forEach(function (swatches) {
      swatches.updateLinks();
    });
  });

  class ColourGroupSwatches extends HTMLElement {
    connectedCallback() {
      if (colourGroupChosenSize === null) this.readSizeFromUrl();
      this.updateLinks();

      // Re-apply on activation too, in case the section was re-rendered after the pick.
      this.addEventListener('click', () => this.updateLinks(), true);
      this.addEventListener('auxclick', () => this.updateLinks(), true);

      if (this.hasAttribute('data-collapse')) {
        var showMore = this.querySelector('[data-toggle="show-more"]');
        var hideMore = this.querySelector('[data-toggle="hide-more"]');

        if (showMore) {
          showMore.addEventListener('click', () => {
            this.setAttribute('data-expanded', '');
            showMore.setAttribute('aria-expanded', 'true');
          });
        }
        if (hideMore) {
          hideMore.addEventListener('click', () => {
            this.removeAttribute('data-expanded');
            showMore.setAttribute('aria-expanded', 'false');
          });
        }
      }
    }

    readSizeFromUrl() {
      var variantId = new URLSearchParams(window.location.search).get('variant');
      var current = this.querySelector('a[aria-current="true"]');
      if (!variantId || !current) return;

      var sizes = colourGroupSizeMap(current);
      for (var size in sizes) {
        if (String(sizes[size]) === variantId) colourGroupChosenSize = size;
      }
    }

    updateLinks() {
      var currentPath = window.location.pathname;
      var links = this.querySelectorAll('a[data-handle]');

      for (var i = 0; i < links.length; i++) {
        var link = links[i];
        var handle = link.dataset.handle;
        var newPath = currentPath.replace(
          /\/products\/[^/?#]+/,
          '/products/' + handle
        );

        // This page's variant id means nothing on another product; swap in the
        // linked product's variant for the chosen size (sold out shows as sold out).
        var params = new URLSearchParams(window.location.search);
        params.delete('variant');
        var variantId = colourGroupChosenSize !== null ? colourGroupSizeMap(link)[colourGroupChosenSize] : null;
        if (variantId) params.set('variant', variantId);

        var search = params.toString();
        link.href = newPath + (search ? '?' + search : '');
      }
    }
  }

  if (!customElements.get('colour-group-swatches')) {
    customElements.define('colour-group-swatches', ColourGroupSwatches);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["colourway-options"] && !Shopify.designMode) return;
  try {
    // Same idea as colour-group-swatches: the size the shopper picked here is carried
  // to the other version, and every other query param (Shoplift's ?view=) is kept.
  let colourwayOptionsChosenSize = null;

  function colourwayOptionsSizeMap(link) {
    try {
      return JSON.parse(link.dataset.sizeVariants || '{}');
    } catch (error) {
      return {};
    }
  }

  document.addEventListener('variant:update', (event) => {
    const variant = event.detail && event.detail.resource;
    if (!variant || !variant.option1) return;

    colourwayOptionsChosenSize = String(variant.option1);
    for (const options of document.querySelectorAll('colourway-options')) options.updateLinks();
  });

  class ColourwayOptions extends HTMLElement {
    connectedCallback() {
      if (colourwayOptionsChosenSize === null) this.#readSizeFromUrl();
      this.updateLinks();

      // Re-apply on activation too, in case the section was re-rendered after the pick.
      this.addEventListener('click', () => this.updateLinks(), true);
      this.addEventListener('auxclick', () => this.updateLinks(), true);
    }

    #readSizeFromUrl() {
      const variantId = new URLSearchParams(window.location.search).get('variant');
      const current = this.querySelector('[aria-current="page"]');
      if (!variantId || !current) return;

      const sizes = colourwayOptionsSizeMap(current);
      for (const size in sizes) {
        if (String(sizes[size]) === variantId) colourwayOptionsChosenSize = size;
      }
    }

    updateLinks() {
      for (const link of this.querySelectorAll('a[data-handle]')) {
        const params = new URLSearchParams(window.location.search);
        params.delete('variant');
        const variantId = colourwayOptionsChosenSize !== null ? colourwayOptionsSizeMap(link)[colourwayOptionsChosenSize] : null;
        if (variantId) params.set('variant', variantId);

        const path = window.location.pathname.replace(/\/products\/[^/?#]+/, `/products/${link.dataset.handle}`);
        const search = params.toString();
        link.href = path + (search ? `?${search}` : '');
      }
    }
  }

  if (!customElements.get('colourway-options')) {
    customElements.define('colourway-options', ColourwayOptions);
  }
  } catch(e) { console.error(e); }
})();

})();
